import _Vue from 'vue'
import AppUpdateReminder from '../utils/AppUpdateReminder'

const appUpdateReminderPlugin = {
  install(Vue) {
    Vue.$appUpdateReminder = new AppUpdateReminder()
  },
}

_Vue.use(appUpdateReminderPlugin)
